import styled from 'styled-components';
import color from 'tinycolor2';

export const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  width: 100%;

  margin: 10px 0;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Label = styled.div`
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme['color.text.body']};
  flex: 1;
  margin-right: 20px;
`;

export const SelectWrapper = styled.div`
  position: relative;

  flex: 1;
  max-width: 323px;
  height: 100%;
`;

export const Select = styled.select`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 4px;
  padding: 7px 30px 7px 11px;
  background-color: ${(props) => props.theme['color.input.background']};
  color: ${(props) => props.notSelected ? props.theme['color.text.light'] : props.theme['color.text.body']};
  cursor: ${(props) => props.disabled ? 'not-allowed' : 'pointer'};
  appearance: none;
  font-size: 14px;
  font-family: inherit;
  line-height: 1;
  box-sizing: border-box;
  transition: box-shadow 0.3s ease;
  opacity: ${(props) => props.disabled ? '0.2' : '1'};
  box-shadow: inset 0 0 0 1px ${(props) => props.theme['color.input.border']};

  &:focus {
    box-shadow: inset 0 0 0 2px ${(props) => props.theme['color.primary']};
    outline: none;
  }
`;

export const CaretDown = styled.svg`
  position: absolute;
  fill: ${(props) => color(props.theme['color.text.light']).setAlpha(color(props.theme['color.text.light']).getAlpha() * 0.8).toString()};
  right: 8px;
  top: 8px;
  width: 24px;
  height: 24px;
  pointer-events: none;
  opacity: ${(props) => props.disabled ? '0.2' : '1'};
`;
